export default function Step4() {
    return (
        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 20.2942H21.9375M13 29.9584H21.9375M26.0625 20.2942H35M13 25.2569H21.9375M26.0625 30.2942V25.9132C26.0625 25.5507 26.3703 25.2569 26.75 25.2569H35" stroke="black" strokeWidth="2.5" strokeLinecap="round"/>
            <circle cx="24" cy="24.2942" r="18" stroke="black" strokeWidth="2.5"/>
        </svg>
    );
}
